import type { IObjectiveExitStrategyApplicantsProposeToRepayLoan } from './ObjectiveExitStrategyApplicantsProposeToRepayLoan.interface';

export default class ObjectiveExitStrategyApplicantsProposeToRepayLoan
  implements IObjectiveExitStrategyApplicantsProposeToRepayLoan {
  repaymentOfLoanPriorToRetirement: boolean;
  downsizingHome: boolean;
  saleOfAssets: boolean;
  recurringIncomeFromSuperannuation: boolean;
  superAnnuationLumpSumFollowingRetirement: boolean;
  savings: boolean;
  incomeFromOtherInvestments: boolean;
  coApplicantsIncome: boolean;
  other: boolean;
  otherComments: string;

  static build = (data: IObjectiveExitStrategyApplicantsProposeToRepayLoan) =>
    new ObjectiveExitStrategyApplicantsProposeToRepayLoan(data);

  static blank = () => new ObjectiveExitStrategyApplicantsProposeToRepayLoan();

  /**
   * Constructor
   * @param {IObjectiveExitStrategyApplicantsProposeToRepayLoan} data
   */
  constructor(data?: IObjectiveExitStrategyApplicantsProposeToRepayLoan) {
    this.repaymentOfLoanPriorToRetirement = data?.repaymentOfLoanPriorToRetirement === true;
    this.downsizingHome = data?.downsizingHome === true;
    this.saleOfAssets = data?.saleOfAssets === true;
    // TODO: data?.recurringIncomeFromSuperAnnuation is legacy data structure
    this.recurringIncomeFromSuperannuation =
      data?.recurringIncomeFromSuperAnnuation === true ||
      data?.recurringIncomeFromSuperannuation === true;
    this.superAnnuationLumpSumFollowingRetirement =
      data?.superAnnuationLumpSumFollowingRetirement === true;
    this.savings = data?.savings === true;
    this.incomeFromOtherInvestments = data?.incomeFromOtherInvestments === true;
    this.coApplicantsIncome = data?.coApplicantsIncome === true;
    this.other = data?.other === true;
    this.otherComments = data?.otherComments || '';
  }
}
